import * as React from 'react';
import styled, { injectGlobal } from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenter } from '../Flexbox/Flexbox';
import { Icon } from '../Defaults';

const Wrapper: any = styled(FlexRowCenter)`
  display: ${(props: any) => (props.isVisible ? 'flex' : 'none')};
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: ${({ theme }) => theme.index.modal};
`;

const ContentWrapper = styled(FlexRowCenter)`
  padding: ${rem(30)};
  background: #fff;
  border-radius: ${({ theme }) => theme.borderRadius || `${rem(6)}`};
  opacity: 1;
  position: fixed;

  &.width90 {
    @media all and (max-width: 900px) {
      width: 90%;
    }
  }
`;

const CloseIcon = styled(FlexRowCenter)`
  width: ${rem(12)};
  height: ${rem(12)};
  position: absolute;
  top: ${rem(21)};
  right: ${rem(21)};

  &:hover {
    cursor: pointer;
  }
`;

interface ModalWindowProps {
  children: React.ReactNode;
  isVisible: boolean;
  handleHideModal: () => void;
  className?: string;
  closeIcon?: boolean;
  hideOnEscPress?: boolean;
}

const bodyOverflowHiddenClass = 'modal-opened';

export class ModalWindow extends React.Component<ModalWindowProps> {
  static defaultProps = {
    closeIcon: true,
    hideOnEscPress: true,
  };

  private wrapperRef: HTMLElement;

  constructor(props) {
    super(props);

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleKeyup = this.handleKeyup.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    document.addEventListener('keyup', this.handleKeyup);
    // /* tslint:disable */
    // injectGlobal`
    //   body.${bodyOverflowHiddenClass} {
    //     overflow: hidden;
    //   }
    // `;
    // /* tslint:enable */
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isVisible === true && this.props.isVisible === false) {
      document.body.classList.add(bodyOverflowHiddenClass);
    }
    if (nextProps.isVisible === false && this.props.isVisible === true) {
      document.body.classList.remove(bodyOverflowHiddenClass);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    document.body.classList.remove(bodyOverflowHiddenClass);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutside(e) {
    if (this.wrapperRef && !this.wrapperRef.contains(e.target)) {
      this.props.handleHideModal();
    }
  }

  handleKeyup(e) {
    if (e.key === 'Escape' && this.props.hideOnEscPress) {
      this.props.handleHideModal();
    }
  }

  render() {
    const {
      isVisible,
      children,
      handleHideModal,
      className,
      closeIcon,
    } = this.props;
    return (
      <Wrapper isVisible={isVisible}>
        <ContentWrapper className={className} innerRef={this.setWrapperRef}>
          {closeIcon && (
            <CloseIcon onClick={handleHideModal}>
              <Icon src={'/images/cancel.svg'} />
            </CloseIcon>
          )}
          {children}
        </ContentWrapper>
      </Wrapper>
    );
  }
}
